// 'TopTenOnLiveTvTray': //AXB-75
import { TopOnLiveTvItem, TopTenOnLiveTvTray } from '../../../domain/top-ten-on-live-tv-tray';
import {
  CreateTopTenLiveTvPageItemRequestApiModel,
  TopTenLiveTvPageItemApiModel,
  UpdateTopTenLiveTvPageItemRequestApiModel,
} from '@cxb/editor-stb-api';
import { mapperPipe, remainderMapper } from 'osn-shared';
import {
  displayServiceTypeIconMapperDomainToApi,
  nameLocalizedMapperDomainToApi,
  scheduledDateMapperDomainToApi,
  targetingMapperDomainToApi,
} from '../../mapping/create-tray-domain-to-api';
import {
  commonMapper,
  nameLocalizedMapperApiToDomain,
  scheduledDateMapperApiToDomain,
  targetingMapperApiToDomain,
} from '../../mapping/create-tray-api-to-domain';
import { TopTenOnLiveTvTrayFormViewModel } from './top-ten-on-live-tv-tray-form.view-model';
import { TrayFormViewModelType } from '../view-model-common/view-model-type';
import {
  displayServiceTypeIconMapper,
  nameLocalizedMapperDomainToViewModel,
  scheduledDateMapperDomainToViewModel,
  targetingMapper,
} from '../create-tray-screen/mapping/create-tray-domain-to-vm';
import {
  nameLocalizedMapperViewModelToDomain,
  scheduledDateMapperViewModelToDomain,
} from '../create-tray-screen/mapping/create-tray-vm-to-domain';

// 'TopTenOnLiveTvTray'

/**
 * DOMAIN -> API
 */

export const mapTopTenOnLiveTVTrayDomainModelToApiModel = (
  item: TopTenOnLiveTvTray,
  pageVersionId?: string,
  tenantId?: string
): CreateTopTenLiveTvPageItemRequestApiModel & UpdateTopTenLiveTvPageItemRequestApiModel => {
  const commonProperties = mapperPipe(
    item,
    nameLocalizedMapperDomainToApi,
    targetingMapperDomainToApi,
    scheduledDateMapperDomainToApi,
    displayServiceTypeIconMapperDomainToApi
  );

  return remainderMapper(commonProperties, () => ({
    pageVersionId,
    items: item.items.map((itemItem) => ({
      order: itemItem.order,
      programId: itemItem.programId,
      instanceId: itemItem.instanceId,
      channelId: itemItem.channel.id,
      programmingTime: itemItem.programStartTime,
      programmingEndTime: itemItem.programEndTime,
    })),
    tenantId,
  }));
};

/**
 * API -> DOMAIN
 */

export const mapTopTenOnLiveTVTrayApiModelToDomainModel = (pageItem: TopTenLiveTvPageItemApiModel): TopTenOnLiveTvTray => {
  return remainderMapper(
    mapperPipe(
      pageItem,
      commonMapper,
      nameLocalizedMapperApiToDomain,
      targetingMapperApiToDomain,
      scheduledDateMapperApiToDomain,
      displayServiceTypeIconMapperDomainToApi
    ),
    () => ({
      type: 'TopTenOnLiveTvTray',
      items: pageItem.items
        .sort((item) => item.order)
        .map((item) => ({
          id: item.id,
          order: item.order,
          channel: {
            id: item.channel.id,
            channelName: item.channel.channelName,
            channelNumber: item.channel.channelNumber,
            channelID: item.channel.channelId,
          },
          programStartTime: item.programmingTime,
          programEndTime: item.programmingEndTime,
          programId: item.programId,
          instanceId: item.instanceId,
        })),
    })
  );
};

/**
 * DOMAIN -> VIEWMODEL
 */

export const mapTopTenOnLiveTvTrayDomainModelToViewModel = (pageItem: TopTenOnLiveTvTray): TopTenOnLiveTvTrayFormViewModel => {
  const commonProperties = mapperPipe(
    pageItem,
    commonMapper,
    nameLocalizedMapperDomainToViewModel,
    targetingMapper,
    scheduledDateMapperDomainToViewModel,
    displayServiceTypeIconMapper
  );

  return remainderMapper(commonProperties, () => ({
    type: TrayFormViewModelType.TopTenOnLiveTvTray,
    items: pageItem.items.map((item, index) => ({
      id: item.id,
      index: index + 1,
      name: undefined,
      programSelector: {
        channel: item.channel,
        programId: item.programId,
        programStartTime: item.programStartTime,
        programEndTime: item.programEndTime,
        instanceId: item.instanceId,
      },
    })),
  }));
};

/**
 * VIEWMODEL -> DOMAIN
 */

export const mapTopTenOnLiveTvTrayViewModelToDomainModel = (vm: TopTenOnLiveTvTrayFormViewModel): TopTenOnLiveTvTray => {
  const commonProperties = mapperPipe(
    vm,
    commonMapper,
    nameLocalizedMapperViewModelToDomain,
    targetingMapper,
    scheduledDateMapperViewModelToDomain,
    displayServiceTypeIconMapper
  );

  return remainderMapper(commonProperties, () => ({
    type: 'TopTenOnLiveTvTray',
    items: vm.items.map<TopOnLiveTvItem>((item, index) => ({
      id: item.id,
      order: index,
      channel: item.programSelector.channel,
      programStartTime: new Date(item.programSelector.programStartTime).getTime(),
      programEndTime: new Date(item.programSelector.programEndTime).getTime(),
      programId: item.programSelector.programId,
      instanceId: item.programSelector.instanceId,
    })),
  }));
};
